import { BaseSyntheticEvent, PropsWithChildren } from 'react';

import { useAppDispatch } from '../../../../../../store/hooks';
import { uploadFiles } from '../../../../thunks/upload-files.thunk';
import { DragAndDropProps } from '../../models/drag-and-drop.model';
import { preventDefaults } from '../../util/prevent-defaults/prevent-defaults.util';

export const useHandleFileChange = (
  callbackFunction: (file: File) => void,
  props: PropsWithChildren<DragAndDropProps>
): ((event: BaseSyntheticEvent) => void) => {
  const dispatch = useAppDispatch();
  return (event: BaseSyntheticEvent): void => {
    preventDefaults(event);
    if (event.target.files && event.target.files.length > 0) {
      const targetFiles: File[] = Array.from(event.target.files);
      targetFiles.forEach(element => {
        return dispatch(
          uploadFiles({
            file: element,
            onFileUploadCallback: callbackFunction,
            onFileRequestCallback: props.uploadHandler,
            fileType: props.fileType,
            splitIntoChunks: !!props.splitIntoChunks,
          })
        );
      });
    }
  };
};
